var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-toolbar-item',{staticClass:"top-ico",attrs:{"disabled":_vm.disabled,"to":_vm.to},on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }